import React from "react";
import Navbar from "./Navbar";
import { Outlet } from "react-router-dom";
import Footer from "./Footer";

const Layout = () => {
  return (
    <div className="bg-white">
      {/* Fixed navbar */}
      <div className="fixed top-5 left-0 w-full z-40">
        <div className="container max-w-7xl mx-auto px-4">
          <Navbar />
        </div>
      </div>

      <Outlet />

      {/* Footer */}
      <footer className="mt-10">
        <Footer />
      </footer>
    </div>
  );
};

export default Layout;
